<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="inspectionScheduleResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" withCustomRowActions
                                      ref="emTable" importEnabled
                                      :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template slot="customRowActions" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button type="edit"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   showName
                                                   customLabel="设备详情"
                                                   @click="goToPlanEquipmentDetail(customRowScope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template slot="right-header">
                                    <b-button-group>
                                        <em-button type="runPlans" v-menu-permission="'edit'"
                                                   v-bind:class="'btn btn-outline-primary'"
                                                   showName
                                                   @click="$_emPlanHelperMixin_runPlans">
                                        </em-button>
                                        <em-button type="runDuePlans" v-menu-permission="'edit'"
                                                   v-bind:class="'btn btn-outline-primary'"
                                                   showName
                                                   @click="$_emPlanHelperMixin_runDuePlans">
                                        </em-button>
                                        <em-button type="runPlans"
                                                   v-bind:class="'btn btn-outline-primary'"
                                                   showName
                                                   custom-label="btn.basic.copy.manual.execution.plan"
                                                   @click="handleRunManualPlans">
                                        </em-button>
                                        <em-button type="copy" v-menu-permission="'edit'"
                                                   v-bind:class="'btn btn-outline-primary'"
                                                   showName
                                                   custom-label="btn.basic.copy.inspectionPlan"
                                                   :busy="onCopy"
                                                   :disabled="actionDisabled('selectOne')"
                                                   v-b-modal.modal-copySchedule>
                                        </em-button>
                                    </b-button-group>

                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <b-modal id="modal-copySchedule" title="复制计划" hide-footer>
            <b-form @submit="handleCopyScheduleSubmit">
                <b-form-group
                    id="setBatch-group"
                    label="新计划名:"
                    label-for="input-schedule-name"
                >
                    <b-form-input id="input-schedule-name" v-model="scheduleName"
                                  placeholder="请输入新计划名"></b-form-input>
                </b-form-group>
                <b-row align-h="end" style="margin-top: 30px">
                    <b-button type="submit" variant="primary">确定</b-button>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>
<script>
// Author YuJiaBei
// Date 2021-06-23 20:52:54

import emCommonListMixin from "@/mixin/em/common/list";
import commonViewsUtil from "@/utils/commonViewsUtil";
import emPlanHelperMixin from "@/mixin/em/helper/plan";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import emApiMixin from "@/mixin/em/common/api";

export default {
    name: "inspectionScheduleListView",
    mixins: [emCommonListMixin, emPlanHelperMixin, emTableCheckedMixin, emApiMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            onCopy: false,
            scheduleName: ''
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    methods: {
        goToPlanEquipmentDetail(inspectionPlan) {
            commonViewsUtil.gotoHolderList(this, "inspectionScheduleEquipment", {inspectionScheduleIdFilter: inspectionPlan.id}, {inspectionScheduleId: inspectionPlan.id})
        },
        handleRunManualPlans() {
            this.$_emPlanHelperMixin_runPlanManual().then(response => {
                this.$router.push({name: `inspectionWorkOrderList`, query: {pathType: 'todo'}});
            })
        },
        handleCopyScheduleSubmit(event) {
            event.preventDefault()
            this.onCopy = true;
            this.$_emApiMixin_post(`${this.$_emApiMixin_entityBaseApi(this.modelName)}/copy?planId=${this.selectIds}&planName=${this.scheduleName}`, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "复制成功")
                    this.$refs.emListFilter.doQuery()
                }).finally(() => this.onCopy = false);
            this.$nextTick(() => {
                this.$bvModal.hide('modal-copySchedule')
            })
        },
    }
};
</script>